import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox"];
const _hoisted_2 = ["x1", "y1", "x2", "y2", "stroke-width", "stroke-dasharray"];
const _hoisted_3 = ["points"];
import { computed } from "vue";
const color = "#09B378";
const headSize = 10;
export default /*@__PURE__*/ _defineComponent({
    __name: 'UArrow',
    props: {
        direction: { default: "down" },
        variant: { default: "dashed" },
        length: { default: 120 },
        thickness: { default: 2 }
    },
    setup(__props) {
        const props = __props;
        const isVertical = computed(() => props.direction === "up" || props.direction === "down");
        const svgWidth = computed(() => isVertical.value ? props.thickness + 10 : props.length);
        const svgHeight = computed(() => isVertical.value ? props.length : props.thickness + 10);
        const viewBox = computed(() => `0 0 ${svgWidth.value} ${svgHeight.value}`);
        const dashArray = computed(() => props.variant === "dashed" ? "6 6" : "0");
        const line = computed(() => {
            if (props.direction === "down") {
                return {
                    x1: svgWidth.value / 2,
                    y1: 0,
                    x2: svgWidth.value / 2,
                    y2: props.length - headSize
                };
            }
            if (props.direction === "up") {
                return {
                    x1: svgWidth.value / 2,
                    y1: headSize,
                    x2: svgWidth.value / 2,
                    y2: props.length
                };
            }
            if (props.direction === "right") {
                return {
                    x1: 0,
                    y1: svgHeight.value / 2,
                    x2: props.length - headSize,
                    y2: svgHeight.value / 2
                };
            }
            // left
            return {
                x1: headSize,
                y1: svgHeight.value / 2,
                x2: props.length,
                y2: svgHeight.value / 2
            };
        });
        const arrowHeadPoints = computed(() => {
            const w = svgWidth.value;
            const h = svgHeight.value;
            if (props.direction === "down") {
                return `${w / 2 - 6},${props.length - headSize}
            ${w / 2 + 6},${props.length - headSize}
            ${w / 2},${props.length}`;
            }
            if (props.direction === "up") {
                return `${w / 2 - 6},${headSize}
            ${w / 2 + 6},${headSize}
            ${w / 2},0`;
            }
            if (props.direction === "right") {
                return `${props.length - headSize},${h / 2 - 6}
            ${props.length - headSize},${h / 2 + 6}
            ${props.length},${h / 2}`;
            }
            // left
            return `${headSize},${h / 2 - 6}
          ${headSize},${h / 2 + 6}
          0,${h / 2}`;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                width: svgWidth.value,
                height: svgHeight.value,
                viewBox: viewBox.value,
                xmlns: "http://www.w3.org/2000/svg"
            }, [
                _createElementVNode("line", {
                    x1: line.value.x1,
                    y1: line.value.y1,
                    x2: line.value.x2,
                    y2: line.value.y2,
                    stroke: color,
                    "stroke-width": __props.thickness,
                    "stroke-dasharray": dashArray.value,
                    "stroke-linecap": "round"
                }, null, 8, _hoisted_2),
                _createElementVNode("polygon", {
                    points: arrowHeadPoints.value,
                    fill: color
                }, null, 8, _hoisted_3)
            ], 8, _hoisted_1));
        };
    }
});
